
const Page01 = (props) => {

    return(
        <div className="col space-between">
            <div className="row">
                <h1 className="title-text">Choose how your company would like to invest in Mississippi:</h1>
            </div>
            <div className="row"></div>
            <div className="row"></div>
            <div className="responsive-row space-between">
                <div className="option-col">
                    <p className="f-gray f-14">Option</p>
                    <div className="number-circle">
                        <p  className="f-16 f-yellow">
                            1
                        </p>
                    </div>
                    <p className="f-yellow f-12">METRIC TONS</p>
                    <br></br>
                    <p className="f-12">Offset your carbon footprint by the metric ton.</p>
                    <button onClick={() => {
                        props.setPage('tons');
                        props.userInputType('tons');
                }}>Continue</button>
                </div>
                <div className="option-line mr-1"></div>
                <div className="option-col">
                     <p className="f-gray f-14">Option</p>
                    <div className="number-circle">
                        <p  className="f-16 f-yellow">
                            2
                        </p>
                    </div>
                    <p className="f-yellow f-12">DOLLARS INVESTED</p>
                    <br></br>
                    <p className="f-12">Offset carbon based on your budget.</p>
                    <button  onClick={() => {
                        props.setPage('dollars')
                        props.userInputType("dollars")}}>Continue</button>
                </div>
                <div className="option-line ml-1"></div>
                <div className="option-col">
                     <p className="f-gray f-14">Option</p>
                     <div className="number-circle">
                        <p  className="f-16 f-yellow">
                            3
                        </p>
                    </div>
                    <p className="f-yellow f-12">SOLAR WATTS</p>
                    <br></br>
                    <p className="f-12">Help us reach our 5 million watt goal.</p>
                    <button onClick={() => {
                        props.setPage('watts')
                        props.userInputType("watts")}}>Continue</button>
                </div>

            </div>


        </div>
    )
}

export default Page01;